/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAskRouteImport } from './routes/_authenticated/ask'
import { Route as AuthenticatedCatalogRouteImport } from './routes/_authenticated/catalog'
import { Route as AuthenticatedConnectionsRouteImport } from './routes/_authenticated/connections'
import { Route as AuthenticatedDiscountsRouteImport } from './routes/_authenticated/discounts'
import { Route as AuthenticatedEnablementRouteImport } from './routes/_authenticated/enablement'
import { Route as AuthenticatedFeedbackRouteImport } from './routes/_authenticated/feedback'
import { Route as AuthenticatedGovernanceRouteImport } from './routes/_authenticated/governance'
import { Route as AuthenticatedInsightsRouteImport } from './routes/_authenticated/insights'
import { Route as AuthenticatedKbRouteImport } from './routes/_authenticated/kb'
import { Route as AuthenticatedMarketRouteImport } from './routes/_authenticated/market'
import { Route as AuthenticatedPackagingRouteImport } from './routes/_authenticated/packaging'
import { Route as AuthenticatedPricesRouteImport } from './routes/_authenticated/prices'
import { Route as AuthenticatedSkillsRouteImport } from './routes/_authenticated/skills'
import { Route as AuthenticatedWorkflowDesignerRouteImport } from './routes/_authenticated/workflow-designer'
import { Route as AuthenticatedAgentsAgentRocketRouteImport } from './routes/_authenticated/agents.agent-rocket'
import { Route as AuthenticatedAskThreadIdRouteImport } from './routes/_authenticated/ask.$threadId'
import { Route as AuthenticatedWorkflowsCodeRouteImport } from './routes/_authenticated/workflows.$code'
import { Route as AuthenticatedWorkflowsAssessmentRouteImport } from './routes/_authenticated/workflows.assessment'
import { Route as AuthenticatedWorkflowsGuidedPackagingRouteImport } from './routes/_authenticated/workflows.guided-packaging'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAskRoute = AuthenticatedAskRouteImport.update({
  id: '/ask',
  path: '/ask',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCatalogRoute = AuthenticatedCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedConnectionsRoute =
  AuthenticatedConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDiscountsRoute = AuthenticatedDiscountsRouteImport.update({
  id: '/discounts',
  path: '/discounts',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedEnablementRoute = AuthenticatedEnablementRouteImport.update({
  id: '/enablement',
  path: '/enablement',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedFeedbackRoute = AuthenticatedFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedGovernanceRoute = AuthenticatedGovernanceRouteImport.update({
  id: '/governance',
  path: '/governance',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedInsightsRoute = AuthenticatedInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedKbRoute = AuthenticatedKbRouteImport.update({
  id: '/kb',
  path: '/kb',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedMarketRoute = AuthenticatedMarketRouteImport.update({
  id: '/market',
  path: '/market',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedPackagingRoute = AuthenticatedPackagingRouteImport.update({
  id: '/packaging',
  path: '/packaging',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedPricesRoute = AuthenticatedPricesRouteImport.update({
  id: '/prices',
  path: '/prices',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSkillsRoute = AuthenticatedSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedWorkflowDesignerRoute =
  AuthenticatedWorkflowDesignerRouteImport.update({
    id: '/workflow-designer',
    path: '/workflow-designer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAgentsAgentRocketRoute =
  AuthenticatedAgentsAgentRocketRouteImport.update({
    id: '/agents/agent-rocket',
    path: '/agents/agent-rocket',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAskThreadIdRoute =
  AuthenticatedAskThreadIdRouteImport.update({
    id: '/$threadId',
    path: '/$threadId',
    getParentRoute: () => AuthenticatedAskRoute,
  } as any)
const AuthenticatedWorkflowsCodeRoute =
  AuthenticatedWorkflowsCodeRouteImport.update({
    id: '/workflows/$code',
    path: '/workflows/$code',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWorkflowsAssessmentRoute =
  AuthenticatedWorkflowsAssessmentRouteImport.update({
    id: '/workflows/assessment',
    path: '/workflows/assessment',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWorkflowsGuidedPackagingRoute =
  AuthenticatedWorkflowsGuidedPackagingRouteImport.update({
    id: '/workflows/guided-packaging',
    path: '/workflows/guided-packaging',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/ask': typeof AuthenticatedAskRouteWithChildren
  '/catalog': typeof AuthenticatedCatalogRoute
  '/connections': typeof AuthenticatedConnectionsRoute
  '/discounts': typeof AuthenticatedDiscountsRoute
  '/enablement': typeof AuthenticatedEnablementRoute
  '/feedback': typeof AuthenticatedFeedbackRoute
  '/governance': typeof AuthenticatedGovernanceRoute
  '/insights': typeof AuthenticatedInsightsRoute
  '/kb': typeof AuthenticatedKbRoute
  '/market': typeof AuthenticatedMarketRoute
  '/packaging': typeof AuthenticatedPackagingRoute
  '/prices': typeof AuthenticatedPricesRoute
  '/skills': typeof AuthenticatedSkillsRoute
  '/workflow-designer': typeof AuthenticatedWorkflowDesignerRoute
  '/agents/agent-rocket': typeof AuthenticatedAgentsAgentRocketRoute
  '/ask/$threadId': typeof AuthenticatedAskThreadIdRoute
  '/workflows/$code': typeof AuthenticatedWorkflowsCodeRoute
  '/workflows/assessment': typeof AuthenticatedWorkflowsAssessmentRoute
  '/workflows/guided-packaging': typeof AuthenticatedWorkflowsGuidedPackagingRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/ask': typeof AuthenticatedAskRouteWithChildren
  '/catalog': typeof AuthenticatedCatalogRoute
  '/connections': typeof AuthenticatedConnectionsRoute
  '/discounts': typeof AuthenticatedDiscountsRoute
  '/enablement': typeof AuthenticatedEnablementRoute
  '/feedback': typeof AuthenticatedFeedbackRoute
  '/governance': typeof AuthenticatedGovernanceRoute
  '/insights': typeof AuthenticatedInsightsRoute
  '/kb': typeof AuthenticatedKbRoute
  '/market': typeof AuthenticatedMarketRoute
  '/packaging': typeof AuthenticatedPackagingRoute
  '/prices': typeof AuthenticatedPricesRoute
  '/skills': typeof AuthenticatedSkillsRoute
  '/workflow-designer': typeof AuthenticatedWorkflowDesignerRoute
  '/agents/agent-rocket': typeof AuthenticatedAgentsAgentRocketRoute
  '/ask/$threadId': typeof AuthenticatedAskThreadIdRoute
  '/workflows/$code': typeof AuthenticatedWorkflowsCodeRoute
  '/workflows/assessment': typeof AuthenticatedWorkflowsAssessmentRoute
  '/workflows/guided-packaging': typeof AuthenticatedWorkflowsGuidedPackagingRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRoute
  '/_authenticated/ask': typeof AuthenticatedAskRouteWithChildren
  '/_authenticated/catalog': typeof AuthenticatedCatalogRoute
  '/_authenticated/connections': typeof AuthenticatedConnectionsRoute
  '/_authenticated/discounts': typeof AuthenticatedDiscountsRoute
  '/_authenticated/enablement': typeof AuthenticatedEnablementRoute
  '/_authenticated/feedback': typeof AuthenticatedFeedbackRoute
  '/_authenticated/governance': typeof AuthenticatedGovernanceRoute
  '/_authenticated/insights': typeof AuthenticatedInsightsRoute
  '/_authenticated/kb': typeof AuthenticatedKbRoute
  '/_authenticated/market': typeof AuthenticatedMarketRoute
  '/_authenticated/packaging': typeof AuthenticatedPackagingRoute
  '/_authenticated/prices': typeof AuthenticatedPricesRoute
  '/_authenticated/skills': typeof AuthenticatedSkillsRoute
  '/_authenticated/workflow-designer': typeof AuthenticatedWorkflowDesignerRoute
  '/_authenticated/agents/agent-rocket': typeof AuthenticatedAgentsAgentRocketRoute
  '/_authenticated/ask/$threadId': typeof AuthenticatedAskThreadIdRoute
  '/_authenticated/workflows/$code': typeof AuthenticatedWorkflowsCodeRoute
  '/_authenticated/workflows/assessment': typeof AuthenticatedWorkflowsAssessmentRoute
  '/_authenticated/workflows/guided-packaging': typeof AuthenticatedWorkflowsGuidedPackagingRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/admin'
    | '/ask'
    | '/catalog'
    | '/connections'
    | '/discounts'
    | '/enablement'
    | '/feedback'
    | '/governance'
    | '/insights'
    | '/kb'
    | '/market'
    | '/packaging'
    | '/prices'
    | '/skills'
    | '/workflow-designer'
    | '/agents/agent-rocket'
    | '/ask/$threadId'
    | '/workflows/$code'
    | '/workflows/assessment'
    | '/workflows/guided-packaging'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/admin'
    | '/ask'
    | '/catalog'
    | '/connections'
    | '/discounts'
    | '/enablement'
    | '/feedback'
    | '/governance'
    | '/insights'
    | '/kb'
    | '/market'
    | '/packaging'
    | '/prices'
    | '/skills'
    | '/workflow-designer'
    | '/agents/agent-rocket'
    | '/ask/$threadId'
    | '/workflows/$code'
    | '/workflows/assessment'
    | '/workflows/guided-packaging'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/auth'
    | '/_authenticated/admin'
    | '/_authenticated/ask'
    | '/_authenticated/catalog'
    | '/_authenticated/connections'
    | '/_authenticated/discounts'
    | '/_authenticated/enablement'
    | '/_authenticated/feedback'
    | '/_authenticated/governance'
    | '/_authenticated/insights'
    | '/_authenticated/kb'
    | '/_authenticated/market'
    | '/_authenticated/packaging'
    | '/_authenticated/prices'
    | '/_authenticated/skills'
    | '/_authenticated/workflow-designer'
    | '/_authenticated/agents/agent-rocket'
    | '/_authenticated/ask/$threadId'
    | '/_authenticated/workflows/$code'
    | '/_authenticated/workflows/assessment'
    | '/_authenticated/workflows/guided-packaging'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthRoute: typeof AuthRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ask': {
      id: '/_authenticated/ask'
      path: '/ask'
      fullPath: '/ask'
      preLoaderRoute: typeof AuthenticatedAskRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/catalog': {
      id: '/_authenticated/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof AuthenticatedCatalogRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/connections': {
      id: '/_authenticated/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof AuthenticatedConnectionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/discounts': {
      id: '/_authenticated/discounts'
      path: '/discounts'
      fullPath: '/discounts'
      preLoaderRoute: typeof AuthenticatedDiscountsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/enablement': {
      id: '/_authenticated/enablement'
      path: '/enablement'
      fullPath: '/enablement'
      preLoaderRoute: typeof AuthenticatedEnablementRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/feedback': {
      id: '/_authenticated/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AuthenticatedFeedbackRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/governance': {
      id: '/_authenticated/governance'
      path: '/governance'
      fullPath: '/governance'
      preLoaderRoute: typeof AuthenticatedGovernanceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/insights': {
      id: '/_authenticated/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AuthenticatedInsightsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/kb': {
      id: '/_authenticated/kb'
      path: '/kb'
      fullPath: '/kb'
      preLoaderRoute: typeof AuthenticatedKbRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/market': {
      id: '/_authenticated/market'
      path: '/market'
      fullPath: '/market'
      preLoaderRoute: typeof AuthenticatedMarketRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/packaging': {
      id: '/_authenticated/packaging'
      path: '/packaging'
      fullPath: '/packaging'
      preLoaderRoute: typeof AuthenticatedPackagingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/prices': {
      id: '/_authenticated/prices'
      path: '/prices'
      fullPath: '/prices'
      preLoaderRoute: typeof AuthenticatedPricesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/skills': {
      id: '/_authenticated/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof AuthenticatedSkillsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/workflow-designer': {
      id: '/_authenticated/workflow-designer'
      path: '/workflow-designer'
      fullPath: '/workflow-designer'
      preLoaderRoute: typeof AuthenticatedWorkflowDesignerRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agents/agent-rocket': {
      id: '/_authenticated/agents/agent-rocket'
      path: '/agents/agent-rocket'
      fullPath: '/agents/agent-rocket'
      preLoaderRoute: typeof AuthenticatedAgentsAgentRocketRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ask/$threadId': {
      id: '/_authenticated/ask/$threadId'
      path: '/$threadId'
      fullPath: '/ask/$threadId'
      preLoaderRoute: typeof AuthenticatedAskThreadIdRouteImport
      parentRoute: typeof AuthenticatedAskRoute
    }
    '/_authenticated/workflows/$code': {
      id: '/_authenticated/workflows/$code'
      path: '/workflows/$code'
      fullPath: '/workflows/$code'
      preLoaderRoute: typeof AuthenticatedWorkflowsCodeRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/workflows/assessment': {
      id: '/_authenticated/workflows/assessment'
      path: '/workflows/assessment'
      fullPath: '/workflows/assessment'
      preLoaderRoute: typeof AuthenticatedWorkflowsAssessmentRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/workflows/guided-packaging': {
      id: '/_authenticated/workflows/guided-packaging'
      path: '/workflows/guided-packaging'
      fullPath: '/workflows/guided-packaging'
      preLoaderRoute: typeof AuthenticatedWorkflowsGuidedPackagingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedAskRouteChildren {
  AuthenticatedAskThreadIdRoute: typeof AuthenticatedAskThreadIdRoute
}

const AuthenticatedAskRouteChildren: AuthenticatedAskRouteChildren = {
  AuthenticatedAskThreadIdRoute: AuthenticatedAskThreadIdRoute,
}

const AuthenticatedAskRouteWithChildren =
  AuthenticatedAskRoute._addFileChildren(AuthenticatedAskRouteChildren)

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRoute
  AuthenticatedAskRoute: typeof AuthenticatedAskRouteWithChildren
  AuthenticatedCatalogRoute: typeof AuthenticatedCatalogRoute
  AuthenticatedConnectionsRoute: typeof AuthenticatedConnectionsRoute
  AuthenticatedDiscountsRoute: typeof AuthenticatedDiscountsRoute
  AuthenticatedEnablementRoute: typeof AuthenticatedEnablementRoute
  AuthenticatedFeedbackRoute: typeof AuthenticatedFeedbackRoute
  AuthenticatedGovernanceRoute: typeof AuthenticatedGovernanceRoute
  AuthenticatedInsightsRoute: typeof AuthenticatedInsightsRoute
  AuthenticatedKbRoute: typeof AuthenticatedKbRoute
  AuthenticatedMarketRoute: typeof AuthenticatedMarketRoute
  AuthenticatedPackagingRoute: typeof AuthenticatedPackagingRoute
  AuthenticatedPricesRoute: typeof AuthenticatedPricesRoute
  AuthenticatedSkillsRoute: typeof AuthenticatedSkillsRoute
  AuthenticatedWorkflowDesignerRoute: typeof AuthenticatedWorkflowDesignerRoute
  AuthenticatedAgentsAgentRocketRoute: typeof AuthenticatedAgentsAgentRocketRoute
  AuthenticatedWorkflowsCodeRoute: typeof AuthenticatedWorkflowsCodeRoute
  AuthenticatedWorkflowsAssessmentRoute: typeof AuthenticatedWorkflowsAssessmentRoute
  AuthenticatedWorkflowsGuidedPackagingRoute: typeof AuthenticatedWorkflowsGuidedPackagingRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,
  AuthenticatedAskRoute: AuthenticatedAskRouteWithChildren,
  AuthenticatedCatalogRoute: AuthenticatedCatalogRoute,
  AuthenticatedConnectionsRoute: AuthenticatedConnectionsRoute,
  AuthenticatedDiscountsRoute: AuthenticatedDiscountsRoute,
  AuthenticatedEnablementRoute: AuthenticatedEnablementRoute,
  AuthenticatedFeedbackRoute: AuthenticatedFeedbackRoute,
  AuthenticatedGovernanceRoute: AuthenticatedGovernanceRoute,
  AuthenticatedInsightsRoute: AuthenticatedInsightsRoute,
  AuthenticatedKbRoute: AuthenticatedKbRoute,
  AuthenticatedMarketRoute: AuthenticatedMarketRoute,
  AuthenticatedPackagingRoute: AuthenticatedPackagingRoute,
  AuthenticatedPricesRoute: AuthenticatedPricesRoute,
  AuthenticatedSkillsRoute: AuthenticatedSkillsRoute,
  AuthenticatedWorkflowDesignerRoute: AuthenticatedWorkflowDesignerRoute,
  AuthenticatedAgentsAgentRocketRoute: AuthenticatedAgentsAgentRocketRoute,
  AuthenticatedWorkflowsCodeRoute: AuthenticatedWorkflowsCodeRoute,
  AuthenticatedWorkflowsAssessmentRoute: AuthenticatedWorkflowsAssessmentRoute,
  AuthenticatedWorkflowsGuidedPackagingRoute:
    AuthenticatedWorkflowsGuidedPackagingRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthRoute: AuthRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
